import { useState } from "react";
import OptionsPriceCalculator from "./components/OptionsPrice";
import Fibonacci from "./components/Fibonacci";
import PivotPointsCalculator from "./components/PivotPoints";

const CalculatorsPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Tab definitions
  const tabs = ["Options Price", "Fibonacci", "Pivot Points"];

  // Get header text based on active tab
  const getHeaderText = () => {
    switch (activeTab) {
      case 0:
        return "Black & Scholes option pricing calculator";
      case 1:
        return "Fibonacci calculator";
      case 2:
        return "Pivot points calculator";
      default:
        return "Calculator";
    }
  };

  // Tab content components
  const tabContents = [
    <OptionsPriceCalculator />,
    <Fibonacci />,
    <PivotPointsCalculator />,
  ];

  return (
    <div className="min-h-screen">
      <div className="mx-auto mt-8">
        {/* Custom Tab Bar */}
        <div className="rounded p-3 w-full">
          <div className="h-8 flex">
            {tabs.map((tab, index) => (
              <div className="tabs tabs-boxed bg-p400 rounded h-11 justify-between w-full p-[4px] ">
                <button
                  key={index}
                  className={`tab w-full h-9 text-sm font-medium  rounded  ${
                    activeTab === index
                      ? "bg-n200 text-p300 font-semibold"
                      : "text-n500"
                  }`}
                  onClick={() => setActiveTab(index)}>
                  {tab}
                </button>
              </div>
            ))}
          </div>
        </div>

        {/* Dynamic Header Text */}
        <div className="my-4">
          <h2 className="text-sm font-semibold text-p300 text-center">{getHeaderText()}</h2>
        </div>

        {/* Tab Content */}
        <div className="mt-2">{tabContents[activeTab]}</div>
      </div>
    </div>
  );
};

export default CalculatorsPage;
